
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bank",
      function () {
        return require("private-next-pages/bank.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bank"])
      });
    }
  